/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import cookie from "cookiejs";

const TIMEOUT = 10 * 60 * 1000;

axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = process.env.REACT_APP_API_REPORT;

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_REPORT,
  timeout: TIMEOUT,
});

let isRefreshing = false;
let failedQueue: any[] = [];

const onRequestSuccess = (config: any) => {
  const accessToken = cookie.get("access_token_report");
  const refreshToken = cookie.get("refresh_token_report");

  config.headers["ngrok-skip-browser-warning"] = "true";

  config.headers["accept"] = "*/*";

  config.headers["Content-Type"] = "application/json";

  config.headers["X-Tenant-Id"] = localStorage.getItem(
    "iam-m-invoice-react.v1.0.0_tenant"
  );

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    config.headers["X-Access-Token"] = `${accessToken}`;
    config.headers["X-Refresh-Token"] = `${refreshToken}`;
  }

  return config;
};

const onResponseError = async (error: any) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve) => {
        failedQueue.push((token: string) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          resolve(instance(originalRequest));
        });
      });
    }

    try {
      isRefreshing = true;
      const refreshToken = cookie.get("refresh_token_report");
      if (!refreshToken) {
        throw new Error("No refresh token");
      }

      const response = await instance.post("/api/auth/refresh");

      const { accessToken, refreshToken: newRefreshToken } = response.data;

      cookie.set("access_token_report", accessToken);
      cookie.set("refresh_token_report", newRefreshToken);

      failedQueue.forEach((prom) => prom(accessToken));
      failedQueue = [];

      originalRequest.headers.Authorization = `Bearer ${accessToken}`;
      return instance(originalRequest);
    } catch (err) {
      cookie.remove("access_token_report");
      cookie.remove("refresh_token_report");

      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }

  return Promise.reject(error);
};

instance.interceptors.request.use(onRequestSuccess);
instance.interceptors.response.use((response) => response, onResponseError);

export default instance;
